import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

export type FieldDescriptionProps = ComponentPropsWithoutRef<'p'>;

const FieldDescription = ({ className, ...props }: FieldDescriptionProps) => {
  return (
    <p
      data-slot="field-description"
      className={cn(
        'text-left text-sm leading-normal font-normal text-gray-600 group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5',
        'last:mt-0 nth-last-2:-mt-1',
        '[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-gray-900',
        className,
      )}
      {...props}
    />
  );
};

export default FieldDescription;
